import { useStore } from 'effector-react'
import * as React from 'react'
import {
  $error,
  $withdrawalGroup,
  getWithdrawalGroup,
  withdrawalGroupMounted,
} from './model'

export const useEditWithdrawalGroup = () => {
  const withdrawalGroup = useStore($withdrawalGroup)
  const loading = useStore(getWithdrawalGroup.pending)
  const error = useStore($error)

  React.useEffect(() => {
    withdrawalGroupMounted()
  }, [])

  return { withdrawalGroup, loading, error }
}
